class DialogModalController {
    constructor($timeout,$sce) {
        "ngInject";
        this.$sce=$sce;
        $('body').on('click',()=>{
            $timeout(()=>{
                this.isActive=false;
            })

        })
    }
}

export default DialogModalController;



// WEBPACK FOOTER //
// ./src/app/common/dialog-modal/dialog-modal.controller.js